import hotel from '../assets/images/slider/hotel.jpg';
import powergenie from '../assets/images/slider/powergenie.jpg';
import mall from '../assets/images/slider/PortImage4.jpg';
import meter1 from '../assets/images/slider/PortImage1.jpg';
import mojecpower from '../assets/images/slider/PortImage3.jpg';
import mojecrealestate from '../assets/images/slider/mojecrealestate.jpg';
import retailjpg from '../assets/images/slider/mojecmeter.jpg';

export const images = [
	{
		img: meter1,
		headerContent: 'Cybersecurity Analyst(Red Teamer, Blue Teamer)',
		descContent:
			'I am a Cybersecurity Analyst with a passion for protecting systems and networks from cyber threats. I specialize in identifying vulnerabilities, implementing security measures, and ensuring the integrity of digital assets.',
	},
	{
		img: mall,
		headerContent: 'DevOps Engineer',
		descContent:
			'I am a DevOps Engineer with a passion for automating processes and improving collaboration between development and operations teams. I specialize in continuous integration, continuous deployment, and infrastructure as code.',
	},
	{
		img: mojecpower,
		headerContent: 'BackEnd Engineer',
		descContent:
			'I also creat and maintain technology at the back end of a website (the server, database and application) and work with the front-end developers and other team members to establish objectives and design more functional, cohesive codes to enhance the user experience. ',
	}
];
